import { Helmet } from 'react-helmet-async';
import RewardCard from './components/RewardCard';
import RewardList from './components/RewardList';

const RewardPage = () => {
  return (
    <>
      <Helmet>
        <title>Reward | Caltex StarCard</title>
      </Helmet>
      <RewardCard />
      <RewardList />
    </>
  );
};

export default RewardPage;
